import { connect } from 'react-redux';
import { widget } from '../../../../src/web/components/widgets/decorators';
import compose from '../../../../src/web/utils/react/compose';
import {
  changeCategory,
  changeItemCount,
  resetCounts,
} from '../../../../src/web/store/modules/storageCalculator';
import StorageCalculator from './StorageCalculator';
import { BUILDER } from '../../../../src/shared/abilities';
import { NAME, ID } from './properties';

const component = compose(
  widget(
    {
      name: NAME,
      category: 'Functions',
      componentId: ID,
    },
    {
      menu: { items: ['delete'] },
    },
  ),
  connect(
    ({ storageCalculator }) => ({ ...storageCalculator }),
    {
      onChangeCategory: changeCategory,
      onChangeCount: changeItemCount,
      onResetCounts: resetCounts,
    },
  ),
)(StorageCalculator);

component.authorization = {
  action: 'manage',
  subject: BUILDER,
};

export default component;
